// @ts-nocheck
/* eslint-disable global-require */

"use client";

import type { BoxProps } from "@mui/material/Box";

import Image from "next/image";
import { forwardRef } from "react";
import { RouterLink } from "#src/routes/components";

import Box from "@mui/material/Box";

import { logoClasses } from "./classes";

// ----------------------------------------------------------------------

export type LogoProps = BoxProps & {
  href?: string;
  disableLink?: boolean;
  fullText?: boolean;
  height?: number;
  width?: number;
};

export const Logo = forwardRef<HTMLDivElement, LogoProps>(
  (
    {
      width = 40,
      height = 40,
      disableLink = false,
      fullText = true,
      className,
      href = "/",
      sx,
      ...other
    },
    ref,
  ) => {
    /*
     * OR using local (public folder)
     * const logo = ( <Box alt="logo" component="img" src={`${CONFIG.site.basePath}/logo/logo-single.svg`} width={width} height={height} /> );
     */

    const logo = (
      <Image
        alt="logo"
        src={fullText ? require("./logo-full.png") : require("./logo.png")}
        width={fullText ? 302 : 120}
        height={120}
      />
    );

    return (
      <Box
        ref={ref}
        component={RouterLink}
        href={href}
        width={fullText ? (height / 120) * 302 : height}
        height={height}
        className={logoClasses.root.concat(className ? ` ${className}` : "")}
        aria-label="logo"
        sx={{
          flexShrink: 0,
          display: "inline-flex",
          verticalAlign: "middle",
          ...(disableLink && { pointerEvents: "none" }),
          ...sx,
        }}
        {...other}
      >
        {logo}
      </Box>
    );
  },
);
